import $ from 'jquery';

var elms = document.getElementsByClassName( 'splide-gallery' );

for ( var i = 0; i < elms.length; i++ ) {
  new Splide( elms[ i ], {
    type: 'slide',
    rewind: false,
    width: '930px',
    cloneStatus: false,
    gap: '6rem',
    arrows: true,
    pagination: false,
    snap: true,
    breakpoints: {
      1199: {
        drag: true,
        width:'600px',
        gap: '4rem',
      },
      767: {
        width:'475px',
        gap: '2rem',
      },
      575: {
        width:'280px',
        gap: '10px',
      },
    }
  }  ).mount();
}

$(window).load(function() {
  var margin_width = ( $('.splide-gallery').outerWidth( true ) - $('.splide-gallery').outerWidth() ) / 2;
  $('.splide__arrows').css({
    "left": "-"+margin_width+"px"
  });
});

$(window).on("resize",function() {
  var margin_width = ( $('.splide-gallery').outerWidth( true ) - $('.splide-gallery').outerWidth() ) / 2;
  $('.splide__arrows').css({
    "left": "-"+margin_width+"px"
  });
});


// WEBPACK FOOTER //
// ../views/blocks/gallery/gallery.js